import React from 'react';
import { Button, Card, Dimmer } from 'tabler-react';
import fetch from '../../support/fetch';
import { status as subscriptionStatus } from '../../support/subscription';
import CardAlert from '../../Components/CardAlert';

class SuspendSubscriptionCard extends React.Component {

    state = {
        showLoader: false,
        alertText: null,
        alertColor: 'danger',
    };

    changeStatus = status => {

        const ok = window.confirm('Deseja realmente continuar com esta ação?');

        if (! ok) {
            return;
        }

        this.setState({
            showLoader: true
        });

        let query;

        switch (status) {
            case 'activate':
                query = `mutation ActivateSubscriptionById ($id: ID!) {
                    activateSubscriptionById (id: $id) {
                        id
                    }
                }`;
                break;

            case 'suspend':
                query = `mutation SuspendSubscriptionById ($id: ID!) {
                    suspendSubscriptionById (id: $id) {
                        id
                    }
                }`;
                break;

            default:
                break;
        }

        fetch.obj({
            query: query,
            variables: {
                id: this.props.subscription.id
            }
        })
        .then(res => {
            if (res.hasOwnProperty('errors')) {
                this.setState({
                    alertText: res.errors[0].debugMessage
                });
            }

            window.location.reload();

            this.setState({
                showLoader: false
            });
        });
    };

    activateHandler = () => {
        this.changeStatus('activate');
    };

    suspendHandler = () => {
        this.changeStatus('suspend');
    };

    render() {

        const { subscription } = this.props;

        const content = () => {
            return (
                <React.Fragment>
                    <p>
                        Este recurso lhe permite congelar temporariamente a cobrança desta assinatura e ativa-la
                        novamente quando você preferir.
                    </p>
                    <p className="mb-0">Enquanto esta assinatura estiver suspensa, seu perfil não estará mais acessível para os seus
                        visitantes e produtores de elenco.
                    </p>
                </React.Fragment>
            );
        };

        return (
            <Card>
                <Card.Header>
                    <h4 className="h4 m-0 text-blue">Suspender Assinatura</h4>
                </Card.Header>

                <Card.Alert color="info" className="text-uppercase text-center">
                    <strong>Ação Temporária</strong>
                </Card.Alert>

                <CardAlert color={this.state.alertColor}>{this.state.alertText}</CardAlert>

                <Card.Body>
                    <Dimmer loader active={!subscription} >
                    {
                        subscription &&
                        subscription.status !== subscriptionStatus.STATUS_CANCELED &&
                        subscription.status !== subscriptionStatus.STATUS_SUSPENDED &&
                        content()
                    }

                    {
                        subscription &&
                        subscription.status === subscriptionStatus.STATUS_CANCELED &&
                        <div className="text-center">
                            <p>Sua assinatura está cancelada e não é possível reativá-la</p>
                        </div>
                    }
                    </Dimmer>
                </Card.Body>

                {
                    subscription &&
                    subscription.status !== subscriptionStatus.STATUS_CANCELED &&
                    subscription.status !== subscriptionStatus.STATUS_SUSPENDED &&
                    <Card.Footer>
                        <Button
                            pill
                            color="info"
                            size="sm"
                            outline={!this.state.showLoader}
                            loading={this.state.showLoader}
                            disabled={this.state.showLoader}
                            onClick={this.suspendHandler}>Suspender</Button>
                    </Card.Footer>
                }


            </Card>
        );
    }
}

export default SuspendSubscriptionCard;